// extracted by mini-css-extract-plugin
export default {"containerMobile":"InfoPage_containerMobile__iIRFP","containerDesktop":"InfoPage_containerDesktop__l2E+c","title":"InfoPage_title__5Ndu4","companyInfo":"InfoPage_companyInfo__KKlfE"};